import Vue from 'vue'
import VueLocalStorage from 'vue-local-storage'

Vue.use(VueLocalStorage)

const divideBySurface = (price, surface) => {
  if (surface === 0 || surface == null) {
    console.error('invalid value of "surface"', surface)
    return price
  }
  return Math.round(price / surface)
}

export default {
  data() {
    return {
      displayPriceBuy:
        this.$localStorage.get('displayPriceBuy') !== null
          ? this.$localStorage.get('displayPriceBuy')
          : 'full',
      displayPriceRent:
        this.$localStorage.get('displayPriceRent') !== null
          ? this.$localStorage.get('displayPriceRent')
          : 'perMonth',
    }
  },
  localStorage: {
    displayPriceRent: {
      type: String,
      default: 'perMonth',
    },
    displayPriceBuy: {
      type: String,
      default: 'full',
    },
  },
  methods: {
    formatPriceNumber(number) {
      const reversedLetters = String(number)
        .split('')
        .reverse()
      let result = ''
      reversedLetters.forEach((letter, index) => {
        result = `${letter}${result}`
        if (index % 3 === 2 && reversedLetters[index + 1]) {
          result = `'${result}`
        }
      })
      return result
    },
    formatPriceRent(price, surface) {
      let priceToDisplay
      switch (this.displayPriceRent) {
        case 'perYear':
          priceToDisplay = price * 12
          break
        case 'perSqmPerYear':
          priceToDisplay = divideBySurface(price * 12, surface)
          break
        default:
          priceToDisplay = price
      }
      return this.formatPriceNumber(priceToDisplay)
    },
    formatPriceBuy(price, surface) {
      let priceToDisplay
      switch (this.displayPriceBuy) {
        case 'perSquareMeter':
          priceToDisplay = divideBySurface(price, surface)
          break
        default:
          priceToDisplay = price
      }
      return this.formatPriceNumber(priceToDisplay)
    },
  },
  watch: {
    displayPriceBuy() {
      this.$localStorage.set('displayPriceBuy', this.displayPriceBuy)
    },
    displayPriceRent() {
      this.$localStorage.set('displayPriceRent', this.displayPriceRent)
    },
  },
}
